import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8837 2.52537C17.0412 2.37046 17.2945 2.37257 17.4494 2.53007L17.9275 3.01615C18.0824 3.17365 18.0803 3.4269 17.9228 3.58181L3.91229 17.3617C3.75479 17.5166 3.50153 17.5145 3.34662 17.357L2.86854 16.8709C2.71364 16.7134 2.71574 16.4601 2.87324 16.3052L6.99998 12.2464V5.50004C6.99998 4.89335 7.36544 4.3464 7.92595 4.11422C8.48646 3.88205 9.13164 4.01039 9.56064 4.43938L12.3835 6.95147L16.8837 2.52537ZM11.3636 7.95457L8.49998 5.5V10.7711L11.3636 7.95457ZM15 9L21.0087 14.4489C21.2265 14.65 21.3055 14.9605 21.2101 15.2412C21.1148 15.5219 20.8631 15.7201 20.5679 15.7469L16.1622 16.1474L17.6708 19.1646C17.856 19.5351 17.7059 19.9856 17.3354 20.1708L14.3354 21.6708C14.1522 21.7624 13.9395 21.7751 13.7467 21.7059C13.5539 21.6368 13.3978 21.4918 13.3146 21.3046L11.728 17.7346L8.49386 20.5644C8.27239 20.7582 7.76795 21.1216 7.49997 21C7.04629 20.7941 6.99997 20.2943 6.99997 20V16L8.49997 14.6367V18.5L11.5061 15.9356C11.6854 15.7787 11.9287 15.7163 12.1614 15.7676C12.3941 15.8188 12.5886 15.9776 12.6853 16.1954L14.3666 19.9782L15.9937 19.1646L14.3292 15.8354C14.2183 15.6137 14.2242 15.3516 14.3448 15.135C14.4654 14.9185 14.6852 14.7755 14.9321 14.7531L18.7507 14.4059L14 10L15 9Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgUnClick = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgUnClick;
